import defaultsDeep from 'lodash/defaultsDeep';
import themeOptionsBase from '../themeOptionsBase';
import * as components from './components';
import palette from './palette';
import shadows from './shadows';
import typography from './typography';
const themeOptionsVariant1 = defaultsDeep({
  typography,
  palette,
  components,
  shadows
}, themeOptionsBase);
export default themeOptionsVariant1;